module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8623/img/favicon.png"